import React from "react";
import styles from "./ProfileCard.module.css";
import { Link } from "react-router-dom";

export default function TagsList({
  tags,
  onClick,
  tagsSize,
  showMore,
  profileId,
}) {
  return (
    <div className={styles.tags}>
      {tagsSize
        ? tags.slice(0, tagsSize).map((tag, index) => (
            <span key={index} className={styles.tag}>
              {tag}
            </span>
          ))
        : tags.map((tag, index) => (
            <span key={index} className={styles.tag}>
              {tag}
            </span>
          ))}
      {showMore && tagsSize && tags.length > tagsSize && (
        <Link className={styles.moreLink} to={`/mentors/${profileId}`}>
          +{tags.length - tagsSize} more
        </Link>
      )}
    </div>
  );
}
